﻿import { useNavigate } from "react-router-dom";
import CustomBadge from "@/components/desktop/badge/CustomBadge";

import classes from "../maintainers.module.scss";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";
import { ReactComponent as ChileSvg } from "@/assets/images/desktop/flags/chile.svg";
import { ReactComponent as UruguaySvg } from "@/assets/images/desktop/flags/uruguay.svg";

const CustomersTableBody = ({ customers, categories, handleDelete, handleStatus }) => {
	const navigate = useNavigate();

	return (
		<tbody>
			{customers &&
				customers.map((item, i) => {
					return (
						<tr className={`${classes.table_tr}`} key={i}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div}  ${classes.first_div}`}>{i + 1}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} `}>{item.name}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>
									<div className={classes.icon_number} onClick={() => navigate("/mantenedores/clientes/editar/" + item.id)}>
										{item.tools.length}
									</div>
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} `}>
									<div style={{ display: "flex", flexWrap: "wrap" }}>
										{categories &&
											categories.map((category, i) => {
												if (
													item.category_id &&
													item.category_id.length > 0 &&
													item.category_id.split(",").includes(String(category.value))
												) {
													return (
														<div key={i}>
															<CustomBadge style={{ marginRight: "3px" }} variant="neutral">
																{category.label}
															</CustomBadge>
														</div>
													);
												}
												return "";
											})}
									</div>
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>
									{item.active_customer ? (
										<CustomBadge style={{ marginRight: "3px", cursor: "pointer" }} variant="success" onClick={() => handleStatus(item)}>
											Activo
										</CustomBadge>
									) : (
										<CustomBadge style={{ marginRight: "3px", cursor: "pointer" }} variant="danger" onClick={() => handleStatus(item)}>
											Inactivo
										</CustomBadge>
									)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center} `}>
									{String(item.country_id) === "1" ? (
										<ChileSvg style={{ width: "1.5em", height: "1.5em", marginRight: "3px" }} />
									) : (
										<UruguaySvg style={{ width: "1.5em", height: "1.5em", marginRight: "3px" }} />
									)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.last_div}`}>
									<PencilSvg className={classes.icon} onClick={() => navigate("/mantenedores/clientes/editar/" + item.id)} />
									<RemoveSvg className={classes.icon} onClick={() => handleDelete(item)} />
								</div>
							</td>
						</tr>
					);
				})}
		</tbody>
	);
};

export default CustomersTableBody;
